import React from 'react';
import { ImageProps } from '.';

const SvgZigzagSymbolCircle = ({ size = 76, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 1)) || 76} fill='none' viewBox='0 0 76 76' {...props}>
      <circle cx={38} cy={38} r={38} fill='#FA6EE3' />
      <path fill='#000' d='M24.93 17.75v9.524h11.672L24.25 58.5h26.82v-9.545H39.486L51.75 17.75H24.93Z' />
    </svg>
  );
};

export default SvgZigzagSymbolCircle;
